import { render, staticRenderFns } from "./NkBoxTitle.vue?vue&type=template&id=5780e22a&scoped=true"
import script from "./NkBoxTitle.vue?vue&type=script&lang=js"
export * from "./NkBoxTitle.vue?vue&type=script&lang=js"
import style0 from "./NkBoxTitle.vue?vue&type=style&index=0&id=5780e22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780e22a",
  null
  
)

export default component.exports